import React, { useEffect, useState } from "react";

import {
  FaPlus,
  FaFilter,
  FaTrash,
  FaEdit,
  FaCheckCircle,
  FaEye,
} from "react-icons/fa";

import AppPagination from "../components/AppPagination";

import TodoModal from "../components/Modals/TodoModal";

import DeleteModal from "../components/Modals/DeleteModal";

const Todo = () => {
  // Modal States
  const [showTodoModal, setShowTodoModal] = useState(false);

  const [viewMode, setViewMode] = useState(false);

  const [editData, setEditData] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [deleteId, setDeleteId] = useState(null);

  // Filter
  const [showFilter, setShowFilter] = useState(false);

  // Loading
  const [loading, setLoading] = useState(true);
    useEffect(() => {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }, []);
  

  const [showViewModal, setShowViewModal] = useState(false);

  const [viewData, setViewData] = useState(null);

  // Todo Data
  const todoData = [
    {
      id: 1,
      title: "Complete Dashboard",
      priority: "High",
      date: "2026-05-18",
      assigned_to: "Amit Sharma",
      status: "Pending",
    },

    {
      id: 2,
      title: "Client Followup Call",
      priority: "Medium",
      date: "2026-05-20",
      assigned_to: "Rahul Verma",
      status: "Completed",
    },

    {
      id: 3,
      title: "Invoice Send",
      priority: "Low",
      date: "2026-05-22",
      assigned_to: "Sonia Mehta",
      status: "Pending",
    },
  ];

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 5;

  const indexOfLastItem = currentPage * itemsPerPage;

  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = todoData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(todoData.length / itemsPerPage);

  // Delete
  const handleDelete = () => {
    console.log(deleteId);

    setShowDeleteModal(false);
  };

  return (
    <div className="lead-page">
      {/* Header */}
      <div className="lead-header">
        <div>
          <h2 className="mb-1">Todo</h2>
        </div>

        <button
          className="btn btn-primary"
          onClick={() => {
            setEditData(null);
            setViewMode(false);
            setShowTodoModal(true);
          }}
        >
          <FaPlus className="me-1" />
          Add Todo
        </button>
      </div>

      {/* Card */}
      <div className="card mb-4 card-light">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="card-title mb-0">All Todo List</h5>

          <div className="d-flex gap-2 align-items-center">
            {showFilter && (
              <input
                type="text"
                className="form-control"
                placeholder="Search Todo"
              />
            )}

            <button
              className="btn btn-dark"
              onClick={() => setShowFilter(!showFilter)}
            >
              <FaFilter className="me-1" />
              Filter
            </button>
          </div>
        </div>

        <div className="card-body">
          <div className="table-outer border">
            <div className="table-responsive">
              <table className="table m-0 align-middle">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Todo</th>
                    <th>Priority</th>
                    <th>Date</th>
                    <th>Assigned To</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="7" className="text-center py-4">
                        Loading...
                      </td>
                    </tr>
                  ) : currentItems.length > 0 ? (
                    currentItems.map((item) => (
                      <tr key={item.id}>
                        <td>#{item.id}</td>

                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <span className="fw-semibold">{item.title}</span>
                          </div>
                        </td>

                        <td>
                          <span
                            className={`badge bg-transparent ${
                              item.priority === "High"
                                ? "border border-danger text-danger"
                                : item.priority === "Medium"
                                  ? "border border-warning text-warning"
                                  : "border border-info text-info"
                            }`}
                          >
                            {item.priority}
                          </span>
                        </td>

                        <td>{item.date}</td>

                        <td>{item.assigned_to}</td>

                        <td>
                          <span
                            className={`badge ${
                              item.status === "Pending"
                                ? "bg-warning"
                                : item.status === "Completed"
                                  ? "bg-success"
                                  : "bg-danger"
                            }`}
                          >
                            {item.status}
                          </span>
                        </td>

                        <td>
                          <div className="d-flex gap-2">
                            <button
                              className="btn btn-sm btn-info custum_primary"
                              onClick={() => {
                                setEditData(item);
                                setViewMode(true);
                                setShowTodoModal(true);
                              }}
                            >
                              <FaEye />
                            </button>
                            {/* Edit */}
                            <button
                              className="btn btn-sm btn-info custum_edit text-white"
                              onClick={() => {
                                setEditData(item);
                                setViewMode(false);
                                setShowTodoModal(true);
                              }}
                            >
                              <FaEdit />
                            </button>

                            {/* Delete */}
                            <button
                              className="btn btn-sm btn-info custum_danger"
                              onClick={() => {
                                setDeleteId(item.id);
                                setShowDeleteModal(true);
                              }}
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center py-4">
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          <div className="row mt-2 p-2">
            <div className="col-md-12">
              <AppPagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={todoData.length}
                itemsPerPage={itemsPerPage}
                onPageChange={setCurrentPage}
              />
            </div>
          </div>
        </div>
      </div>

      <TodoModal
        show={showTodoModal}
        setShow={setShowTodoModal}
        editData={editData}
        viewMode={viewMode}
      />
      <DeleteModal
        show={showDeleteModal}
        setShow={setShowDeleteModal}
        onConfirm={handleDelete}
        title="Delete Todo?"
        message="Are you sure you want to delete this todo?"
      />
    </div>
  );
};

export default Todo;
